import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Whatwedo from "./components/Whatwedo";
import Simple from "./components/Simple";
import Section from "./components/Section";
import "./App.css";
import Section1 from "./components/Section1";
import Brands from "./components/Brands";
import Reseller from "./components/Reseller";
import Minisosec from "./components/Minisosec";
import Brandlogos from "./components/Brandlogos";
import Explainer from "./components/Explainer";
import Getintouch from "./components/Getintouch";
import Footer from "./components/Footer";
import WhatsapIcon from "./utils/WhatsapIcon";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Section1 />
      <Whatwedo />
      <Brands />
      <Reseller />
      <Minisosec />
      <Brandlogos />
      <Section className="brand-bg">
        <div className="container sec-pad">
          <Simple />
        </div>
      </Section>
      <Explainer />
      <Getintouch />
      <WhatsapIcon />
      <Footer />
    </div>
  );
}

export default App;
